import React from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { NAVBAR_HEIGHT } from "../../pages/Map";
import { ConsoleSidebar } from "../ui";
import OrgSelector from "./OrgSelector";
import { buildAdminNav } from "./adminNav";
import { useAuthSelector } from "../../store/auth";
import useAuth from "../../hooks/useAuth";

// The admin console lives inside the main app shell (below the TitleBar), like the
// Forms area: MainLayout renders the app TitleBar (nav tabs + user/logout menu) and
// this layout provides the console's own left sidebar + routed content. Sign-out and
// "back to app" are handled by the shared TitleBar, so they're intentionally absent here.
const AdminConsoleLayout: React.FC = () => {
  const { user } = useAuthSelector();
  const { canManageUsers, canManageConfiguration, canManageRestrictions, canBulkApiDataImport } = useAuth();
  const isSuperuser = Boolean(user?.is_superuser);
  const sections = buildAdminNav({
    isSuperuser,
    isStaff: Boolean(user?.is_staff || isSuperuser),
    canManageUsers,
    canManageConfiguration,
    canManageRestrictions,
    canBulkApiDataImport
  });

  return (
    <Box
      sx={{ height: `calc(100vh - ${NAVBAR_HEIGHT})`, width: "100%", display: "flex", overflow: "hidden", bgcolor: "background.default" }}
    >
      <ConsoleSidebar sections={sections} />
      <Box sx={{ flex: 1, minWidth: 0, height: "100%", overflowY: "auto" }}>
        <Box sx={{ mx: "auto", px: { xs: "16px", md: "32px" }, py: "24px" }}>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: "16px" }}></Box>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default AdminConsoleLayout;
